import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-technical-state-renderer',
    template: `
    @if (params.data || params.value) {
      <div class="technical-state-cell" [ngStyle]="color">
        @if (note === null) {
          <div>
            <span class="technical-state-label">
              @if (showWithoutNotation) {
                {{ "Without notation" | translate }}
              } @else {
                -
              }
            </span>
          </div>
        }
        @if (note !== null) {
          <div>
            <span class="technical-state-label">{{ label }}</span>
          </div>
        }
      </div>
    }
    `,
    standalone: true,
    imports: [
      NgStyle,
      TranslateModule
    ],
    styles: [`
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
      .technical-state-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
    `]
})
export class TechnicalStateRendererComponent
  implements ICellRendererAngularComp {
  public params: any;
  public color: any;
  public label: string;
  // the raw note value of the technical state, 
  // used to display the "Without notation" label when the note is null
  public note: number;
  public showWithoutNotation: boolean = true;

  constructor(
  ) { }

  agInit(params: any): void {
    this.params = params;
    this.showWithoutNotation = params.showWithoutNotation;
    const { value } = params;

    if (!!value) {
      const {level, level_label, note} = value;
      this.note = note
      this.label = level_label;
      if (level === 0) { // rebut
        this.color = { 'background-color': '#d9d9d9' };
      }
      else if (level === 1) {
        this.color = { 'background-color': '#ff8b94' };
      } else if (level === 2) {
        this.color = { 'background-color': '#ffaaa5' };
      } else if (level === 3) {
        this.color = { 'background-color': '#dcedc1' };
      } else if (level === 4) {
        this.color = { 'background-color': '#a8e6cf' };
      } else if (level === 5) {
        this.color = { 'background-color': '#a8e6cf' };
      }
    }
  }

  refresh(): boolean {
    return false;
  }
}
